import script from "./LTooltip.vue?vue&type=script&lang=js"
export * from "./LTooltip.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__